var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fold-stake',{attrs:{"name":_vm.t(`Combinations.${_vm.maxFoldCount}`),"fold":_vm.maxFoldCount,"stake":_vm.getFoldStake(_vm.maxFoldCount),"lineCount":_vm.getComboLineCount,"odd":_vm.getComboOdd}})
}
var staticRenderFns = []

export { render, staticRenderFns }